import { api } from './api';

const getAppSettings = async (params) => {
    const response = await api({
        url: 'AppSettings/getAppSetting',
        method: 'GET',
        params,
    });
    return response.data;
};

const getCustomerSmpl = async (customerId, userId) => {
    const response = await api({
        url: `customersmpl`,
        method: 'GET',
        id:'customersmpl',
        cache: {
            ttl: 24 * 60 * 60 * 1000 * 7
        },
        params: {
            customerId
        }
    });
    return response.data;
};

const getPagedList = async ({body, pageNumber = 1, pageSize = 10}) => {
    const response = await api({
        url: `AppSettings/getList`,
        method: 'GET',
        params: {
            Page: pageNumber,
            PageSize: pageSize,
            ...body
        },
    });
    return response.data;
};

const parameterUpdate = async (data) => {
    const response = await api({
        url: `AppSettings`,
        method: 'PUT',
        data,
    });
    return response.data;
};

const appSettingsServices = {
  getAppSettings,
  getCustomerSmpl,
  getPagedList,
  parameterUpdate,
};

export default appSettingsServices;
